




import { defineComponent } from "@vue/composition-api";
import { VueConstructor } from "vue";
import { Appointment } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import { getAppointmentView } from "./views";
import { AppointmentsTabNameEnum } from "../../config";

export default defineComponent({
  name: "AppointmentsItem",
  props: {
    item: { type: Object as () => Appointment, required: true },
    viewMode: { type: String as () => AppointmentsTabNameEnum, required: true },
    authUserId: { type: String, required: true },
  },
  computed: {
    viewComponent(): VueConstructor {
      return getAppointmentView(this.viewMode);
    },
  },
});
